import React from "react";
import { motion } from "framer-motion";
import { FaStar, FaQuoteLeft } from "react-icons/fa";
import "./Testimonials.css";

const testimonials = [
  {
    id: 1,
    name: "Vikram Malhotra",
    role: "Founder & CEO",
    company: "ApexFin Technologies",
    rating: 5,
    result: "+240% Inbound Growth",
    avatar: "VM",
    text: "The Digitexy completely revamped our web architecture and organic search pipeline. Within 90 days, our inbound demo requests tripled, and our site speed improved by over 65%. Highly recommended for any serious business.",
  },
  {
    id: 2,
    name: "Ayesha Khan",
    role: "Head of Marketing",
    company: "NovaScale Solutions",
    rating: 5,
    result: "4.8x Ad ROAS",
    avatar: "AK",
    text: "Their team doesn't just design pretty pages—they understand conversion psychology. The paid performance campaigns and new landing pages cut our cost per acquisition almost in half.",
  },
  {
    id: 3,
    name: "Rohan Singhal",
    role: "Director of Product",
    company: "SwiftLogistics Global",
    rating: 5,
    result: "#1 Google Rankings",
    avatar: "RS",
    text: "Transparent communication, zero fluff, and exceptional technical skill. They solved complex SEO indexing issues that three other agencies couldn't figure out. Our rankings have never been higher.",
  },
  {
    id: 4,
    name: "Pooja Patel",
    role: "Managing Director",
    company: "Aura Home Living",
    rating: 5,
    result: "+310% Conversion Surge",
    avatar: "PP",
    text: "From branding and UI design to post-launch optimization, working with The Digitexy was the smoothest agency experience we've had. Fast, communicative, and truly invested in our revenue.",
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials-section" aria-label="Client testimonials">
      <div className="testimonials-wrap">
        <motion.div
          className="testimonials-head"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="testimonials-kicker">Client Success</span>
          <h2>Trusted by Fast-Growing Companies</h2>
          <p>
            See how our strategic engineering and digital marketing deliver
            tangible business outcomes for founders and leaders.
          </p>
        </motion.div>

        {/* Client Reviews Grid */}
        <div className="testimonials-grid">
          {testimonials.map((item, idx) => (
            <motion.div
              key={item.id}
              className="testimonial-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              whileHover={{ y: -6, transition: { duration: 0.2 } }}
            >
              <div className="test-card-top">
                <div className="test-rating">
                  {[...Array(item.rating)].map((_, i) => (
                    <FaStar key={i} className="star-icon" />
                  ))}
                </div>
                <span className="test-result-badge">{item.result}</span>
              </div>

              <div className="test-quote-icon">
                <FaQuoteLeft />
              </div>

              <p className="test-quote-text">"{item.text}"</p>

              <div className="test-author-box">
                <div className="test-avatar">{item.avatar}</div>
                <div>
                  <h3 className="test-author-name">{item.name}</h3>
                  <div className="test-author-role">
                    {item.role}, <strong>{item.company}</strong>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
